import { c as _c } from "react/compiler-runtime";
import { getEditorGroups, getListStatus, getRemoveXgSeatSteps, getTeamsToLeave, isProjectManager, isWorkspaceAdmin } from "@components/table/members/remove-xg-seat/remove-xg-seat-utils";
import { useMemberEditorProjects } from "@components/table/members/remove-xg-seat/use-member-groups-with-details";
import { useMemberTeams } from "@components/table/members/remove-xg-seat/use-member-teams";
import { useRefetchMember } from "@components/table/members/remove-xg-seat/use-refetch-member";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { companyMemberGroupsSelector, companyMemberGroupsStatusSelector } from "@store/company-member-groups/company-member-groups-selector";
import { companyMemberSelector } from "@store/members/members-selector";
import { useAppSelector } from "@store/store-helper";
import { useEffect, useRef } from "react";
/**
 * Whether the member may hold roles of a kind: when they do, or when that could not be checked,
 * so that the step can tell the user and let them try again.
 */
function mayHoldRoles(status, count) {
  return status === "failed" || count > 0;
}

/**
 * Looks up where the member holds a role that needs a Sphere XG seat while it is mounted, so that
 * the user is only walked through the steps that apply to the member, or not at all. It shows
 * nothing, so whatever mounts it shows that it is busy.
 */
export function RemoveXgSeatCheck(t0) {
  const $ = _c(6);
  const {
    member,
    seatKind: t1,
    onStepsFound
  } = t0;
  const seatKind = t1 === undefined ? "assigned" : t1;
  const hasReportedSteps = useRef(false);
  const {
    teams,
    status: teamsStatus
  } = useMemberTeams(member.identity);
  const {
    projects,
    status: projectsStatus
  } = useMemberEditorProjects(member.identity);
  const groups = useAppSelector(companyMemberGroupsSelector);
  const groupsStatus = getListStatus(useAppSelector(companyMemberGroupsStatusSelector));
  const isMemberLoading = useRefetchMember(member.identity);
  const storedMember = useAppSelector(companyMemberSelector(FaroCoreApiUtils.Member.getMemberId(member))) ?? member;
  const isDone = teamsStatus !== "loading" && projectsStatus !== "loading" && !isMemberLoading;
  let t2;
  if ($[0] !== projects) {
    t2 = projects.filter(_temp);
    $[0] = projects;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const managedProjectCount = t2.length;
  const steps = isDone ? getRemoveXgSeatSteps({
    hasEditorTeams: mayHoldRoles(teamsStatus, getTeamsToLeave(teams, seatKind).length),
    hasEditorGroups: mayHoldRoles(groupsStatus, getEditorGroups(groups).length),
    hasManagedProjects: mayHoldRoles(projectsStatus, managedProjectCount),
    hasEditorProjects: mayHoldRoles(projectsStatus, projects.length - managedProjectCount),
    isWorkspaceAdmin: isWorkspaceAdmin(storedMember)
  }) : undefined;
  let t3;
  let t4;
  if ($[2] !== onStepsFound || $[3] !== steps) {
    t3 = () => {
      if (steps && !hasReportedSteps.current) {
        hasReportedSteps.current = true;
        onStepsFound(steps);
      }
    };
    t4 = [steps, onStepsFound];
    $[2] = onStepsFound;
    $[3] = steps;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return null;
}
function _temp(t0) {
  const {
    project
  } = t0;
  return isProjectManager(project);
}